export default __webpack_public_path__ + "static/media/RoleSpecificAccess_Image.14a7351e.png";